export default __webpack_public_path__ + "static/media/ranking-exp-deduction-step2.87edd0b2.png";